/* eslint-disable react/no-multi-comp */
import { t } from 'i18next';

import { getSubStepValues } from '#models/general/steps';
import { FIVE_NUMBERS_W1_DECIMAL_REGEX } from '#utils/string/regex';
import Checkbox from '#components/general/Checkbox';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';
import Input from '#components/general/Input';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';

import styles from './styles.module.scss';
import { HOUSE_KEEPING_FIELDS, MASH_SUBSTEPS_IDS } from './constants';

export const getHouseKeepingFields = ({ values, errors }) => {
  const getHouseKeepingValues = getSubStepValues(MASH_SUBSTEPS_IDS.HOUSE_KEEPING, values, errors);
  return [
    {
      key: 'titles',
      Component: AdelphiFieldsRow,
      fields: [
        {
          key: 'washbackCleaningTitle1',
          Component: () => (
            <div className={styles.columnTitle}>
              {t(`${MASH_SUBSTEPS_IDS.HOUSE_KEEPING}:lineCleaningAndWaterReading`)}
            </div>
          )
        },
        {
          key: 'washbackCleaningTitle2',
          Component: () => (
            <div className={styles.columnTitle}>
              {t(`${MASH_SUBSTEPS_IDS.HOUSE_KEEPING}:mashTunCleaning`)}
            </div>
          )
        }
      ]
    },
    {
      key: 'washbackCleaningAndWortsCooler',
      Component: AdelphiFieldsRow,
      className: styles.noMarginRow,
      fields: [
        {
          ...getHouseKeepingValues(HOUSE_KEEPING_FIELDS.WORTS_LINE_FLOWRATE),
          Component: Input,
          needsRegex: true,
          customRegex: FIVE_NUMBERS_W1_DECIMAL_REGEX,
          measure: MEASURE_TYPES.FLOWRATE,
          noMargin: true
        },
        {
          ...getHouseKeepingValues(HOUSE_KEEPING_FIELDS.CAUSTIC_CLEANED),
          Component: Checkbox
        }
      ]
    },
    {
      key: 'cipCleanedAndStartingVolumeOfCleaned',
      Component: AdelphiFieldsRow,
      className: styles.noMarginRow,
      fields: [
        {
          ...getHouseKeepingValues(HOUSE_KEEPING_FIELDS.PROCESS_WATER_METER_READING),
          Component: Input,
          needsRegex: true,
          customRegex: FIVE_NUMBERS_W1_DECIMAL_REGEX,
          measure: MEASURE_TYPES.CUBIC_METER,
          noMargin: true
        },
        {
          ...getHouseKeepingValues(HOUSE_KEEPING_FIELDS.MASH_TUN_OPERATOR),
          Component: Input,
          noMargin: true
        }
      ]
    },
    {
      key: 'wortsNotesRow',
      Component: AdelphiFieldsRow,
      className: styles.noMarginRow,
      fields: [
        {
          key: 'thirdEmptyColumnElement',
          Component: () => <div />
        },
        {
          ...getHouseKeepingValues(HOUSE_KEEPING_FIELDS.MASH_TUN_NOTES),
          Component: Input,
          noMargin: true
        }
      ]
    }
  ];
};
